import { subscribeStomp } from "../stompClient";

const TERMINAL_STATUSES = new Set(["COMPLETED", "ALL_COMPLETED", "FAILED", "ALL_FAILED"]);
// Before the job is named, the topic also carries a running job's frames (the wait for the
// scenario lock can last minutes): only the latest few can matter once ours is known.
const MAX_HELD_FRAMES = 20;

/**
 * Listens to a scenario's schedule-update frames for a progress card whose job is followed by
 * status polling alone (multi-project and Programme Gantts). Subscribe BEFORE the request that
 * starts the job: its first frames carry the ETA and can beat the 202 back to the browser.
 * Frames are held until `follow(jobId, onProgress)` names the job, then only that job's
 * non-terminal frames are forwarded. Terminal frames are left to the caller's own follow.
 *
 * @param topic   the user's `/topic/scenario-update/{username}`; null (no username) → inert
 * @param itemId  the scenarioId the frames carry as `itemId`
 * @returns {{ follow(jobId, onProgress): void, stop(): void }}
 */
export function watchJobProgress({ topic, itemId }) {
  const targetIdStr = String(itemId);
  const held = [];
  let jobId;
  let onProgress = null;
  let stopped = false;

  const forward = (frame) => {
    if (jobId && frame.jobId === jobId) onProgress(frame);
  };

  const unsubscribe = topic
    ? subscribeStomp(topic, (message) => {
        if (stopped) return;
        let frame;
        try {
          frame = JSON.parse(message.body);
        } catch {
          return;
        }
        if (frame?.itemId == null || String(frame.itemId) !== targetIdStr) return;
        if (TERMINAL_STATUSES.has(frame.status)) return;
        if (!onProgress) {
          if (held.length >= MAX_HELD_FRAMES) held.shift();
          held.push(frame);
          return;
        }
        forward(frame);
      })
    : () => {};

  return {
    follow(followedJobId, callback) {
      if (stopped) return;
      jobId = followedJobId || null;
      onProgress = callback;
      held.splice(0).forEach(forward);
    },
    stop() {
      if (stopped) return;
      stopped = true;
      held.length = 0;
      unsubscribe();
    },
  };
}
